import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import styles from './index.module.scss';
import getFormatMessage from '../../../../locales/get-format-message';
import { SpriteSvg, SpriteSvgType } from '../../../../components/sprite-svg';

export const ServiceShop = () => {
  const renderModelCard = (cardProps: {
    icon: React.ReactNode;
    title: string;
    desc: string;
    disabled?: boolean;
  }) => {
    const { icon, title, desc } = cardProps;
    return (
      <div className={styles.feeModelCard}>
        <div> {icon}</div>
        <div className={styles.feeCardContent}>
          <span>{title}</span>
          <span>{desc}</span>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className={styles.shopContent}>
        <div>
          <label className={styles.shopCardLabel}>
            {getFormatMessage('order_fee_mode')}
          </label>
          <div>
            {renderModelCard({
              icon: (
                <SpriteSvg
                  type={SpriteSvgType.PayQuantity}
                  className={styles.payQuantityIcon}
                />
              ),
              title: getFormatMessage('order_pay_by_quantity'),
              desc: getFormatMessage('order_pay_by_quantity_desc'),
            })}
          </div>
        </div>
        <div className={styles.shopWarn}>
          <div className={styles.shopWarnIcon}>
            <InfoCircleFilled />
          </div>
          <div className={styles.shopWarnText}>
            <span> {getFormatMessage('order_pay_by_quantity_warn')}</span>
            <span>{getFormatMessage('order_pay_by_quantity_warn_1')}</span>
            <span>
              {getFormatMessage('order_pay_by_quantity_warn_2_1')}
              <span style={{ color: '#F77E45' }}>
                {getFormatMessage('order_pay_by_quantity_warn_2_2')}
              </span>
              {getFormatMessage('order_pay_by_quantity_warn_2_3')}
            </span>
            <span>{getFormatMessage('order_pay_by_quantity_warn_3')}</span>
            <span>{getFormatMessage('order_pay_by_quantity_warn_4')}</span>
          </div>
        </div>

        <div className={styles.shopTips}>
          {getFormatMessage('order_pay_by_quantity_tips')}
        </div>
      </div>
    </>
  );
};
